export const hasInternshipDirectionPermissions = ({ user }) => user.isInternshipDirector
